import {Component, OnInit, ViewChild} from '@angular/core';
import {ClientEnrollmentFormComponent, KcApplicationSubmitType} from '../ClientEnrollmentFormComponent';
import {Client, KcApplicationClient} from '../../../../services/api.client';
import {BehaviorSubject, mergeMap, Observable, of, Subject} from 'rxjs';
import {KcProgram} from '../../../../services/api.client';
import {KcApplicationService} from '../../../../services/KcApplicationService';
import {NotificationService} from '../../../../services/NotificationService';
import {Router, ActivatedRoute} from '@angular/router';
import {SystemService} from '../../../../services/SystemService';
import {KcApplicationResult} from '../../../../services/api.client';
import {ClientService} from '../../../../services/ClientService';
import {SecurityService} from '../../../../services/SecurityService';
import {filter, take} from 'rxjs/operators';

@Component({
    selector: 'clientEditApplication',
    templateUrl: './ClientEditApplicationComponent.html',
    styleUrls: ['./ClientEditApplicationComponent.scss'],
    standalone: false
})

export class ClientEditApplicationComponent implements OnInit {
    @ViewChild(ClientEnrollmentFormComponent)
    form: ClientEnrollmentFormComponent;

    client: Client;
    client$: Observable<Client>;

    kcPrograms: KcProgram[];
    kcPrograms$: Observable<KcProgram[]>;

    application: KcApplicationResult;
    application$: Observable<KcApplicationResult>;

    refreshNotes$ = new Subject<boolean>()

    public isLoaded$ = new BehaviorSubject<boolean>(false);

    constructor(private kcApplicationService: KcApplicationService,
                private notificationService: NotificationService,
                private router: Router,
                private route: ActivatedRoute,
                private system: SystemService,
                private _clientService: ClientService,
                private _kcAppClient: KcApplicationClient,
                private _securityService: SecurityService) {
        this.client$ = this._clientService.currentClient$;
        this.kcPrograms$ = this._securityService.kcStatuses$;
        this.application$ = this.kcApplicationService.currentSelectedKcApplication$;
    }

    ngOnInit(): void {
        this.client$.subscribe(client => this.client = client);
        this.kcPrograms$.subscribe(kcProgram => this.kcPrograms = kcProgram);
        this.kcApplicationService.getKcApplicationById(this.route.snapshot.paramMap.get('applicationId')).subscribe(application => {
            this.application = application;
            this.isLoaded$.next(true);
            }
        );
    }

    onSubmit(type: KcApplicationSubmitType): void {
        switch (type) {
            case 'New':
                break;
            case 'Save':
                break;
            case 'Reject':
                break;
            case 'Cancel':
                break;
            case 'Delete':
                this.router.navigate(['../../'], {relativeTo: this.route}).then();
                break;
            case 'Approve':
                this.refreshNotes$.next(true);
                break;
        }

    }

    ngAfterViewInit(): void {
        this.isLoaded$.pipe(
            filter(val => !!val),
            take(1)
        ).subscribe(_ => {
            this.form.populateEdit(this.application);
            this.form.application = this.application;
            if (this.form.applicationStartedButNotSubmitted) {
                this.form.accountNumberControl.disable();
                this.form.keepingCurrentProgramIdControl.disable();
                this.form.totalAmountOwedControl.disable();
                this.form.upfrontAmountDueControl.disable();
                this.form.grandTotalEstimatedCreditsControl.disable();
                this.form.upfrontPaySourceControl.disable();
            }
        });
    }

    onContinue(): void {
        this.router.navigate(['./request_enrollment'], {relativeTo: this.route}).then();
    }

    ngOnDestroy(): void {
        this.kcApplicationService.setCurrentKcApplicationResult(null);
    }
}
